import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const I18nContext = createContext({ lang: "en", t: (k, f) => f, setLang: () => {}, languages: [] });

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("vsk_lang") || "en");
  const [bundle, setBundle] = useState({});
  const [languages, setLanguages] = useState([{ code: "en", name: "English", rtl: false }]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/i18n/languages").then(({ data }) => setLanguages(data)).catch(() => {});
  }, []);

  useEffect(() => {
    const meta = languages.find((l) => l.code === lang);
    document.documentElement.dir = meta?.rtl ? "rtl" : "ltr";
    document.documentElement.lang = lang;
    if (lang === "en") {
      setBundle({});
      return;
    }
    setLoading(true);
    api.get(`/i18n/bundle/${lang}`, { timeout: 60000 })
      .then(({ data }) => setBundle(data.bundle || {}))
      .catch(() => setBundle({}))
      .finally(() => setLoading(false));
  }, [lang, languages]);

  const setLang = useCallback((code) => {
    localStorage.setItem("vsk_lang", code);
    setLangState(code);
  }, []);

  const t = useCallback((key, fallback) => bundle[key] || fallback, [bundle]);

  return (
    <I18nContext.Provider value={{ lang, t, setLang, languages, loading }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
